module.exports = __webpack_public_path__ + "media/images/e-bilet/Hero_Image_Kyiv-f94ffff1f5eb5e71f428a2cabcca9533.jpg";